import { combineReducers } from '@reduxjs/toolkit';

import { municipalUserStateReducer } from './municipalUserInfoSlice';
import { punchoutUserInfoReducer } from './punchoutUserInfoSlice';
import { userProfileReducer } from './userProfileSlice';

const combined = combineReducers({
    municipalUser: municipalUserStateReducer,
    profile: userProfileReducer,
    punchout: punchoutUserInfoReducer,
});

export default combined;
